<template>
  <div>Start</div>
</template>
<script>
export default {
  mounted() {
    this.$router.push("/login");
  },
};
</script>
<style lang="scss" scoped></style>
